import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type { ClientExpenseListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const mapExpenseDto = (
	dto: ClientExpenseListItemResponseDTO,
): FinanceState["expenses"][number] => ({
	id: dto.id,
	type: dto.type,
	name: dto.name,
	monthlyPayment: dto.monthlyPayment,
	sustainableAmount: dto.sustainableAmount,
});
